import Lock from '@mui/icons-material/Lock';
import { Button, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DataProviderResource } from 'src/constants';

interface LockUserButtonProps {
  id: string;
}

export const LockUserButton = ({ id }: LockUserButtonProps) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const [update, { isLoading }] = useUpdate();

  const onLock = async () => {
    update(
      DataProviderResource.LockUser,
      {
        id,
      },
      {
        onSuccess: () => {
          notify('User successfully locked.', { type: 'success' });
        },
        onSettled: () => {
          refresh();
        },
        onError: err => {
          notify(`Failed to lock user. Received: ${err}`, {
            type: 'error',
          });
        },
      },
    );
  };

  return (
    <Button label={'Lock'} onClick={onLock} disabled={isLoading} style={{ marginTop: '8px' }}>
      <Lock />
    </Button>
  );
};
